import { catchError, filter, map, mergeMap } from 'rxjs/operators';
import { from, of } from 'rxjs';
import RootEpic from 'store/RootEpic';
import ChangeRequestSlice from 'components/pages/console/store/ChangeRequestSlice';
import { getChangeRequest } from 'gql/ChangeRequest';

// GET
export const getChangeRequestEpic: RootEpic = (action$) =>
  action$.pipe(
    filter(ChangeRequestSlice.actions.getChangeRequest.match),
    mergeMap(({ payload }) => {
      return from(getChangeRequest(payload)).pipe(
        map((response) => {
          return ChangeRequestSlice.actions.getChangeRequestSucceeded(response);
        }),
        catchError((error) => {
          return of(ChangeRequestSlice.actions.getChangeRequestFailed(error));
        })
      );
    })
  );

const ChangeRequestEpics: RootEpic[] = [getChangeRequestEpic];

export default ChangeRequestEpics;
